<template>

  <div>

    <div class="row">
      <div class="col-sm">
        <div class="form-group">
          <label class="control-label">* {{ $t('Opening date') }}</label>
          <date 
            :setting="{format: 'DD-MM-YYYY'}"
            v-model="job.date_open">
            </date>
          <ValidateMessage :error="validateErrors.date_open" />
        </div>
      </div>
      <div class="col-sm">
        <div class="form-group">
          <label class="control-label">* {{ $t('Expected closing date') }}</label>
          <date 
            :setting="{format: 'DD-MM-YYYY'}"
            v-model="job.date_close">
            </date>
          <ValidateMessage :error="validateErrors.date_close" />
        </div>
      </div>
    </div>

    <hr>

    <div class="form-group">
      <label class="control-label">* {{ $t('Team') }}</label>
      <select-multiple-user v-model="job.team_users"></select-multiple-user>
      <ValidateMessage :error="validateErrors.team_users" />
    </div>

    <div class="form-check">
      <input class="form-check-input" type="checkbox" v-model="job.confidential">
      <label class="form-check-label" for="defaultCheck1">
        {{ $t('Restricted to team only') }}
      </label>
      <ValidateMessage :error="validateErrors.openings" />
    </div>

  </div>

</template>

<script>
import Date from '@/components/Fields/Date'
import SelectMultipleUser from '@/components/Fields/SelectMultipleUser'

export default {
  name: 'JobFormControl',
  components: {
    Date,
    SelectMultipleUser
  },
  props: [
    'initJob',
    'validateErrors'
  ],
  data () {
    return {
      job: this.$clone(this.initJob)
    }
  },
  watch: {
    job: {
      handler: function (newValue) {
        const {
          date_open,
          date_close,
          team_users,
          confidential
        } = newValue

        this.$emit('changed', {
          date_open,
          date_close,
          team_users,
          confidential
        })
      },
      deep: true
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/JobForm/JobFormControl.vue